import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import CustomerInput from './customerInput.vue';
import { getArea } from '@/api/common';
import { editCustomer as _editCustomer } from '@/api/admissionCounseling/customerDrawerCom';
export default {
  name: 'InfoCom',
  components: {
    CustomerInput: CustomerInput
  },
  dicts: ['education'],
  props: {
    canEdit: {
      type: Object,
      required: true
    },
    drawerForm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      genderOpt: [{
        id: 2,
        label: '未知'
      }, {
        id: 1,
        label: '先生'
      }, {
        id: 0,
        label: '女士'
      }],
      provinces: [],
      // 省份列表
      citys: [],
      // 城市列表
      counties: [],
      // 区
      info: {},
      edit: {
        name: false
      },
      phone: [],
      weChat: [],
      qq: []
    };
  },
  computed: {
    error: function error() {
      var phone = this.phone,
        weChat = this.weChat,
        qq = this.qq;
      var phoneError = phone.filter(function (item) {
        return item.error !== '';
      });
      var weChatError = weChat.filter(function (item) {
        return item.error !== '';
      });
      var qqError = qq.filter(function (item) {
        return item.error !== '';
      });
      return {
        phone: phoneError.length && phoneError[0].error || '',
        weChat: weChatError.length && weChatError[0].error || '',
        qq: qqError.length && qqError[0].error || ''
      };
    },
    canAdd: function canAdd() {
      var canEdit = this.canEdit;
      return canEdit.isFlowCustomerManage ? canEdit.editable : canEdit.isOwner;
    }
  },
  watch: {
    'drawerForm.id': function drawerFormId(newVal) {
      if (newVal) {
        this.info = this.drawerForm;
        var initInput = this.initInput,
          info = this.info,
          getCityList = this.getCityList,
          getCountyList = this.getCountyList;
        initInput();
        if (info.city) {
          getCityList(info.province);
          getCountyList(info.city);
        }
      }
    },
    'drawerForm.lastCommunicationLog': function drawerFormLastCommunicationLog(newVal) {
      this.info.lastCommunicationLog = newVal;
    },
    'error.phone': function errorPhone(val) {
      var editCustomer = this.editCustomer,
        handleDelete = this.handleDelete,
        phone = this.phone;
      if (val === '') {
        editCustomer(true).catch(function () {
          handleDelete(phone.length - 1, 1);
        });
      }
    },
    'error.weChat': function errorWeChat(val) {
      var editCustomer = this.editCustomer,
        handleDelete = this.handleDelete,
        weChat = this.weChat;
      if (val === '') {
        editCustomer(true).catch(function () {
          handleDelete(weChat.length - 1, 2);
        });
      }
    },
    'error.qq': function errorQq(val) {
      var editCustomer = this.editCustomer,
        handleDelete = this.handleDelete,
        qq = this.qq;
      if (val === '') {
        editCustomer(true).catch(function () {
          handleDelete(qq.length - 1, 3);
        });
      }
    }
  },
  created: function created() {
    var provinces = this.provinces,
      getAreaList = this.getAreaList;
    !provinces.length && getAreaList();
  },
  methods: {
    // 获取省份0
    getAreaList: function getAreaList() {
      var _this = this;
      getArea({
        parentId: 0
      }).then(function (res) {
        _this.provinces = res;
      });
    },
    // 获取城市
    getCityList: function getCityList(pId) {
      var _this2 = this;
      getArea({
        parentId: pId
      }).then(function (res) {
        _this2.citys = res;
      });
    },
    // 区
    getCountyList: function getCountyList(pId) {
      var _this3 = this;
      getArea({
        parentId: pId
      }).then(function (res) {
        _this3.counties = res;
      });
    },
    // 选中的省份
    changeProvince: function changeProvince(p) {
      var handleChange = this.handleChange,
        clearCity = this.clearCity,
        getCityList = this.getCityList;
      handleChange();
      clearCity(1);
      getCityList(p);
    },
    // 选中的城市
    changeCity: function changeCity(c) {
      var handleChange = this.handleChange,
        clearCity = this.clearCity,
        getCountyList = this.getCountyList;
      handleChange();
      clearCity(2);
      if (!c) {
        return;
      }
      getCountyList(c);
    },
    clearCity: function clearCity(level) {
      var info = this.info;
      var _this$info = this.info,
        city = _this$info.city,
        cityName = _this$info.cityName,
        county = _this$info.county,
        countyName = _this$info.countyName;
      county && (info.county = undefined);
      countyName && (info.countyName = undefined);
      if (level === 2) {
        return;
      }
      city && (info.city = undefined);
      cityName && (info.cityName = undefined);
    },
    editName: function editName() {
      var edit = this.edit;
      edit.name = !edit.name;
    },
    handleDelete: function handleDelete(deleteIndex, type) {
      var isEdit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // 根据类型过滤号码
      var phone = this.phone,
        weChat = this.weChat,
        qq = this.qq,
        editCustomer = this.editCustomer;
      switch (type) {
        case 1:
          phone.splice(deleteIndex, 1);
          break;
        case 2:
          weChat.splice(deleteIndex, 1);
          break;
        case 3:
          qq.splice(deleteIndex, 1);
          break;
        default:
          break;
      }
      isEdit && editCustomer(true);
    },
    handleAdd: function handleAdd(type) {
      var phone = this.phone,
        commonMsg = this.commonMsg,
        weChat = this.weChat,
        qq = this.qq;
      var item = {
        num: '',
        error: '',
        disabled: false
      };
      switch (type) {
        case 1:
          if (!phone.length || phone[phone.length - 1]) {
            phone.push(item);
          } else {
            commonMsg();
          }
          break;
        case 2:
          if (!weChat.length || weChat[weChat.length - 1]) {
            weChat.push(item);
          } else {
            commonMsg();
          }
          break;
        case 3:
          if (!qq.length || qq[qq.length - 1]) {
            qq.push(item);
          } else {
            commonMsg();
          }
          break;
        default:
          break;
      }
    },
    commonMsg: function commonMsg() {
      this.$message({
        type: 'info',
        message: '请输入空白输入框！'
      });
    },
    handleError: function handleError(data) {
      var phone = this.phone,
        weChat = this.weChat,
        qq = this.qq;
      switch (data.type) {
        case 1:
          phone[data.index].error = "".concat(data.tip, "\uFF08\u7B2C").concat(data.index + 1, "\u4E2A\uFF09");
          break;
        case 2:
          weChat[data.index].error = "".concat(data.tip, "\uFF08\u7B2C").concat(data.index + 1, "\u4E2A\uFF09");
          break;
        case 3:
          qq[data.index].error = "".concat(data.tip, "\uFF08\u7B2C").concat(data.index + 1, "\u4E2A\uFF09");
          break;
        default:
          break;
      }
    },
    handleTrue: function handleTrue(data) {
      var phone = this.phone,
        weChat = this.weChat,
        qq = this.qq,
        error = this.error,
        editCustomer = this.editCustomer,
        handleDelete = this.handleDelete;
      var type = data.type,
        index = data.index,
        val = data.val;
      switch (type) {
        case 1:
          phone[index].num = val;
          phone[index].error !== '' && (phone[index].error = '');
          // 完全没有填错的情况
          if (!error.phone) {
            editCustomer(true).catch(function () {
              handleDelete(index, type, false);
            });
          }
          break;
        case 2:
          weChat[index].num = val;
          weChat[index].error !== '' && (weChat[index].error = '');
          if (!error.weChat) {
            editCustomer(true).catch(function () {
              handleDelete(index, type, false);
            });
          }
          break;
        case 3:
          qq[index].num = val;
          qq[index].error !== '' && (qq[index].error = '');
          if (!error.qq) {
            editCustomer(true).catch(function () {
              handleDelete(index, type, false);
            });
          }
          break;
        default:
          break;
      }
    },
    handleChange: function handleChange() {
      this.editCustomer(false);
    },
    editCustomer: function editCustomer(updateContact) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var info, returnContact, $message, id, name, gender, eduBackground, province, city, county, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              info = _this4.info, returnContact = _this4.returnContact, $message = _this4.$message;
              id = info.id, name = info.name, gender = info.gender, eduBackground = info.eduBackground, province = info.province, city = info.city, county = info.county;
              _context.n = 1;
              return _editCustomer({
                id: id,
                name: name,
                gender: gender,
                edu_background: eduBackground,
                province: province,
                city: city,
                county: county,
                contactPhone: returnContact('phone'),
                contactWechat: returnContact('weChat'),
                contactQq: returnContact('qq'),
                updateContact: updateContact
              });
            case 1:
              res = _context.v;
              if (typeof res === 'string') {
                $message({
                  type: 'success',
                  message: '修改成功~'
                });
                _this4.$emit('refresh');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initInput: function initInput() {
      var _this$info2 = this.info,
        contactPhone = _this$info2.contactPhone,
        contactWechat = _this$info2.contactWechat,
        contactQq = _this$info2.contactQq;
      // 确保容器干净
      var phone = this.phone,
        weChat = this.weChat,
        qq = this.qq;
      phone.length && (this.phone = []);
      weChat.length && (this.weChat = []);
      qq.length && (this.qq = []);
      contactPhone && (this.phone = contactPhone.map(function (item) {
        return {
          num: item,
          error: '',
          disabled: true
        };
      }));
      contactWechat && (this.weChat = contactWechat.map(function (item) {
        return {
          num: item,
          error: '',
          disabled: true
        };
      }));
      contactQq && (this.qq = contactQq.map(function (item) {
        return {
          num: item,
          error: '',
          disabled: true
        };
      }));
    },
    returnContact: function returnContact(key) {
      return this[key].map(function (item) {
        return item.num;
      });
    }
  }
};